module.exports = __webpack_public_path__ + "static/media/sound_correct.af0f389e.mp3";